var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.item.quantity === 0
      ? _c("div", { staticClass: "product__prices not-available" }, [
          _c(
            "div",
            { staticClass: "product__price", staticStyle: { width: "100%" } },
            [_vm._v("Нет в наличии")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "product__buy-action" }, [
            _c(
              "div",
              {
                staticClass:
                  "product__btn send-button form-data__button button button_theme_primary_blue button_size_sm",
                on: {
                  click: function ($event) {
                    return _vm.addWaitingList(_vm.item, +_vm.item.step)
                  },
                },
              },
              [
                _c("span", { staticClass: "btn__text" }, [
                  _vm._v("В лист ожидания"),
                ]),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.item.quantity > 0 || _vm.item.storage.transit !== 0
      ? _c(
          "div",
          {
            staticClass:
              "product__product-summary-controls product-summary-controls product-summary-controls_catalog",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "product-summary-controls__select select select_theme_toggle",
              },
              [
                _c("div", { staticClass: "select__caption" }, [
                  _vm._v("\n        Заказать в\n      "),
                ]),
                _vm._v(" "),
                _c("span"),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.step,
                        expression: "item.step",
                      },
                    ],
                    staticClass: "select__input",
                    attrs: { name: "VARIANT_QUANTITY" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.item,
                          "step",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  _vm._l(_vm.item.packing, function (packing, index) {
                    return _c(
                      "option",
                      {
                        key: index,
                        domProps: {
                          selected: packing.ratio == _vm.item.step,
                          value: packing.ratio,
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(packing.text) +
                            " (" +
                            _vm._s(packing.ratio) +
                            " шт.)\n        "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "product-summary-controls__quantity quantity quantity_size_lg quantity_btn-buy",
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "quantity__button quantity__button_minus",
                    on: {
                      click: function ($event) {
                        return _vm.updateQuantity(_vm.item, -_vm.item.step)
                      },
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "quantity__button-icon icon icon-minus",
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  ref: "inputCount",
                  staticClass: "quantity__input",
                  attrs: {
                    type: "text",
                    name: "QUANTITY_INPUT",
                    placeholder: "0",
                  },
                  domProps: { value: _vm.basketCount },
                  on: {
                    blur: function ($event) {
                      return _vm.updateQuantityInp(
                        _vm.item,
                        $event.target.value
                      )
                    },
                    keypress: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      $event.preventDefault()
                    },
                    click: _vm.inputFocus,
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "quantity__button quantity__button_plus",
                    on: {
                      click: function ($event) {
                        return _vm.updateQuantity(_vm.item, +_vm.item.step)
                      },
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "quantity__button-icon icon icon-plus",
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.item.history
              ? _c(
                  "div",
                  {
                    staticClass:
                      "product__report-link tooltip tooltip_type_data tooltip_order_history",
                    attrs: {
                      "data-tooltipposition": "top",
                      "data-tooltipsize": "large",
                      "data-product-id": "item.id",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "tooltip__title" },
                      [
                        _c(
                          "vue-popper",
                          {
                            attrs: {
                              id: _vm.item.id + "-el-history",
                              placement: "left",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "tooltip",
                                  fn: function () {
                                    return [
                                      _c(
                                        "table",
                                        { staticClass: "table-tooltip" },
                                        [
                                          _c("tr", [
                                            _c("th", [_vm._v("№ заказа")]),
                                            _vm._v(" "),
                                            _c("th", [_vm._v("Дата")]),
                                            _vm._v(" "),
                                            _c("th", [_vm._v("Заказано")]),
                                            _vm._v(" "),
                                            _c("th", [_vm._v("Отгружено")]),
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.item.history.items,
                                            function (order) {
                                              return _c("tr", [
                                                _c("th", [
                                                  _vm._v(_vm._s(order.id)),
                                                ]),
                                                _vm._v(" "),
                                                _c("th", [
                                                  _vm._v(_vm._s(order.date)),
                                                ]),
                                                _vm._v(" "),
                                                _c("th", [
                                                  _vm._v(
                                                    _vm._s(order.quantity_plan)
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("th", [
                                                  _vm._v(
                                                    _vm._s(order.quantity)
                                                  ),
                                                ]),
                                              ])
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2752515146
                            ),
                          },
                          [
                            _vm._v(
                              "\n          Заказывали " +
                                _vm._s(
                                  _vm.item.history.items[0].quantity_plan
                                ) +
                                " шт. " +
                                _vm._s(_vm.item.history.items[0].date) +
                                "\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }